import { gql } from '@apollo/client'

const acceptImDfmMutation = gql`
    mutation acceptDfmFeedbackSlideActionPanel($dfmFeedbackId: UUID!) {
        acceptDfmFeedback(id: $dfmFeedbackId) {
            id
            acceptedAt
            acceptedBy {
                id
                email
            }
            status
        }
    }
`

export default acceptImDfmMutation
